// extracted by mini-css-extract-plugin
export default {"mainBox":"style_mainBox__dOHCh","cardBoxParent":"style_cardBoxParent__SBISR"};